import fetch from "cross-fetch";
import { ApolloClient, ApolloLink, gql, HttpLink, InMemoryCache } from "@apollo/client";
import request, { RequestDocument } from "graphql-request";
import { getCognitoAccessToken } from "../Api";

const authLink = new ApolloLink((operation, forward) => {
  const accessToken = getCognitoAccessToken();

  if (accessToken != null) {
    operation.setContext(({ headers }) => ({
      headers: {
        authorization: `Bearer ${accessToken}`,
        ...headers,
      },
    }));
  }

  return forward(operation);
});

const graphqlServer = `${process.env.REACT_APP_PUBLIC_API_BASE}/graphql`;
const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, new HttpLink({ uri: graphqlServer, fetch })]),
  cache: new InMemoryCache(),
});

const graphqlRequest = async <T = any>(
  document: RequestDocument,
  variables: any = {},
  token?: string | null
) => {
  let accessToken: string | null = null;

  // ID Token Replaced with access token
  if (token) accessToken = await getCognitoAccessToken();

  if (accessToken) {
    return request<T>(graphqlServer, document, variables, {
      authorization: `Bearer ${accessToken}`,
    });
  } else {
    return request<T>(graphqlServer, document, variables);
  }
};

export { gql, graphqlServer, graphqlRequest, apolloClient };
